import api from './api'

export interface RegisterData {
  name: string
  email: string
  password: string
  subdomain: string
  phone?: string
  bio?: string
  specialties?: string[]
  zones?: string[]
}

export interface LoginData {
  email: string
  password: string
}

export interface AuthResponse {
  success: boolean
  token: string
  agent: {
    id: string
    name: string
    email: string
    subdomain: string
    phone?: string
    bio?: string
    specialties: string[]
    zones: string[]
    plan: string
    avatar_url?: string
  }
  message?: string
}

export const authService = {
  async register(data: RegisterData): Promise<AuthResponse> {
    const response = await api.post('/api/auth/register', data)
    return response.data
  },

  async login(data: LoginData): Promise<AuthResponse> {
    const response = await api.post('/api/auth/login', data)
    return response.data
  },

  async getProfile(): Promise<any> {
    const token = localStorage.getItem('token')
    if (!token) throw new Error('No token found')
    const response = await api.get('/api/auth/profile', {
      headers: {
        'Authorization': `Bearer ${token}`
      }
    })
    return response.data
  },

  async forgotPassword(email: string): Promise<{ success: boolean; message: string }> {
    const response = await api.post('/api/auth/forgot-password', { email })
    return response.data
  },

  async resetPassword(token: string, password: string): Promise<{ success: boolean; message: string }> {
    const response = await api.post('/api/auth/reset-password', { token, password })
    return response.data
  },

  async changePassword(currentPassword: string, newPassword: string): Promise<{ success: boolean; message: string }> {
    const token = localStorage.getItem('token')
    if (!token) throw new Error('No token found')
    const response = await api.post('/api/auth/change-password', 
      { currentPassword, newPassword },
      {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      }
    )
    return response.data
  }
}
